<template>
  <div class="solution">
    <div class="solution-container w">
      <!-- 运营商解决方案 -->
      <div class="operator">
        <div class="title" style="margin-bottom: 40px">{{ resourceList.operator.title }}</div>
        <div class="describe">
          <div class="per-paragraph">{{ resourceList.operator.describe }}</div>
        </div>
        <div class="img">
          <img :src="resourceList.operator.url" alt="">
        </div>
      </div>
      <!-- 公共安全解决方案 -->
      <div class="public-security">
        <div class="title" style="margin-bottom: 37px">{{ resourceList.publicSecurity.title }}</div>
        <div class="img">
          <img :src="resourceList.publicSecurity.url" alt="">
        </div>
      </div>
      <!-- 智慧交通解决方案 -->
      <div class="intelligent-transportation">
        <div class="title" style="margin-bottom: 30px">{{ resourceList.intelligentTransportation.title }}</div>
        <div class="img">
          <img :src="resourceList.intelligentTransportation.url" alt="">
        </div>
      </div>
      <!-- 智慧养老解决方案 -->
      <div class="smart-pension">
        <div class="title" style="margin-bottom: 30px">{{ resourceList.smartPension.title }}</div>
        <div class="img">
          <img :src="resourceList.smartPension.url1" alt="">
        </div>
        <div class="img">
          <img :src="resourceList.smartPension.url2" alt="">
        </div>
      </div>
      <!-- 智慧防疫解决方案 -->
      <div class="intelligent-epidemic-prevention">
        <div class="title" style="margin-bottom: 30px">{{ resourceList.intelligentEpidemicPrevention.title }}</div>
        <div class="img">
          <img :src="resourceList.intelligentEpidemicPrevention.url1" alt="">
        </div>
        <div class="img">
          <img :src="resourceList.intelligentEpidemicPrevention.url2" alt="">
        </div>
      </div>
      <!-- 智慧工地解决方案 -->
      <div class="smart-site">
        <div class="title" style="margin-bottom: 30px">{{ resourceList.smartSite.title }}</div>
        <div class="img">
          <img :src="resourceList.smartSite.url" alt="">
        </div>
      </div>
      <!-- 智慧农业解决方案 -->
      <div class="intelligent-agriculture">
        <div class="title" style="margin-bottom: 40px">{{ resourceList.intelligentAgriculture.title }}</div>
        <div class="describe">
          <div class="per-paragraph">{{ resourceList.intelligentAgriculture.describe1 }}</div>
        </div>
        <div class="img">
          <img :src="resourceList.intelligentAgriculture.url1" alt="">
        </div>
        <div class="describe">
          <div class="per-paragraph">{{ resourceList.intelligentAgriculture.describe2 }}</div>
        </div>
        <div class="img">
          <img :src="resourceList.intelligentAgriculture.url2" alt="">
        </div>
      </div>
      <!-- 乡村振兴解决方案 -->
      <div class="rural-revitalization">
        <div class="title" style="margin-bottom: 30px">{{ resourceList.ruralRevitalization.title }}</div>
        <div class="img">
          <img :src="resourceList.ruralRevitalization.url1" alt="">
        </div>
        <div class="describe">
          <div class="per-paragraph">{{ resourceList.ruralRevitalization.describe }}</div>
        </div>
        <div class="img">
          <img :src="resourceList.ruralRevitalization.url2" alt="">
        </div>
      </div>
      <!-- 无人机解决方案 -->
      <div class="drones">
        <div class="title" style="margin-bottom: 30px">{{ resourceList.drones.title }}</div>
        <div class="img">
          <img :src="resourceList.drones.url" alt="">
        </div>
      </div>
      <!-- 工商大数据解决方案 -->
      <div class="business_big_data">
        <div class="title" style="margin-bottom: 40px">{{ resourceList.businessBigData.title }}</div>
        <div class="describe">
          <div class="per-paragraph">{{ resourceList.businessBigData.describe }}</div>
        </div>
        <div class="img">
          <img :src="resourceList.businessBigData.url" alt="">
        </div>
      </div>
      <!-- 动态信控解决方案 -->
      <div class="dynamic-signal-control">
        <div class="title" style="margin-bottom: 40px">{{ resourceList.dynamicSignalControl.title }}</div>
        <div class="describe">
          <div class="per-paragraph">{{ resourceList.dynamicSignalControl.describe }}</div>
        </div>
        <div class="img">
          <img :src="resourceList.dynamicSignalControl.url" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Solution',
  data () {
    return {
      resourceList: {
        operator: {
          title: '运营商解决方案',
          describe: '业务支撑系统是为中大型客户打造的打通线上线下业务办理的系统，具备复杂权限管理、全渠道管理、融合产品管理、多渠道订单管理、平台级支付等能力，将传统的 “坐商”向 “行商”进行转变，辅助客户提升业绩，适用于通信运营商、银行、保险销售、母婴等多种行业及场景。',
          url: 'img/Solution/operator.png'
        },
        publicSecurity: {
          title: '公共安全解决方案',
          url: 'img/Solution/public-security.png'
        },
        intelligentTransportation: {
          title: '智慧交通解决方案',
          url: 'img/Solution/intelligent-transportation.png'
        },
        smartPension: {
          title: '智慧养老解决方案',
          url1: 'img/Solution/smart-pension1.png',
          url2: 'img/Solution/smart-pension2.png'
        },
        intelligentEpidemicPrevention: {
          title: '智慧防疫解决方案',
          url1: 'img/Solution/intelligent-epidemic-prevention1.png',
          url2: 'img/Solution/intelligent-epidemic-prevention2.png'
        },
        smartSite: {
          title: '智慧工地解决方案',
          url: 'img/Solution/smart-site.png'
        },
        intelligentAgriculture: {
          title: '智慧农业解决方案',
          describe1: '通过构建“1+3+N”工程，实现农业数据资源化、生产经营数字化、生产管理可视化、生产装备智能化、农旅融合一体化的数字农业新业态。',
          url1: 'img/Solution/intelligent-agriculture1.png',
          describe2: '结合GIS建模、遥感监测服务，建设农业产业园管理驾驶舱，以多屏联动的方式，全方位展示整个园区的环境状况、农业生产加工过程、产销情况，为园区展示提供可视化平台，科学生产提供数据支持。',
          url2: 'img/Solution/intelligent-agriculture2.png'
        },
        ruralRevitalization: {
          title: '乡村振兴解决方案',
          url1: 'img/Solution/rural-revitalization1.png',
          describe: '面向“区县政府、乡镇政府、村级两委、乡村群众”四类客户，聚焦“基层政府治理、农业农村生产、乡村农民生活”三大板块，打造集“乡村治理、乡村服务、乡村决策”为一体的乡村振兴综合信息服务平台，为政府提供科学治理支持，为产业发展提供信息服务，为村民提供惠民便民服务数智赋能全面助力乡村振兴，全面实现农业强、农村美、农民富。',
          url2: 'img/Solution/rural-revitalization2.png'
        },
        drones: {
          title: '无人机解决方案',
          url: 'img/Solution/drones.png'
        },
        businessBigData: {
          title: '工商大数据解决方案',
          describe: '我司数据均通过正规渠道采至国家工商总局底层数据库，涵盖所有企业及个体工商户，非爬虫数据，数据覆盖面为国内同类最广。对敏感数据采用加密、脱敏方法进行处理，确保数据的安全性及完整性。对数据进行建模分析，辅助各行业透过数据分析解决问题。',
          url: 'img/Solution/business_big_data.png'
        },
        dynamicSignalControl: {
          title: '动态信控解决方案',
          describe: '动态信控服务是对通信运营商信用服务的补充，服务于通信运营商风控体系内无法服务的高风险用户、中低端用户，以确保这部分用户在余额不足时且暂时不方便充值时可以继续使用通信业务。通过多维度专用评估模型，挖掘有消费潜力的移动未授信/低授信用户，通过授信释放其消费的欲望，减少他们停机的次数与时长，从而为运营商带来增量的收入。',
          url: 'img/Solution/dynamic-signal-control.png'
        }
      }
    }
  },
  mounted() {
    // 初次进入页面手动调用一次
    if (this.scrollItem) {
      this.goSolutionItem(this.scrollItem)
    }
  },
  computed: {
    scrollItem() {
      return this.$store.state.scrollItem
    }
  },
  watch: {
    scrollItem(item) {
      this.goSolutionItem(item)
    }
  },
  methods: {
    // 滑动到指定项
    goSolutionItem(className) {
      this.backTimer = -1
      const classItem = document.getElementsByClassName(className)[0]
      const targetLocation = classItem.offsetTop - 64 - 30 // 30为padding-top的距离，使感官更友好
      const top =
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            window.pageYOffset
      let currentTop = top
      if (this.backTimer === -1) {
        this.speed = 40
        this.backTimer = setInterval(() => {
          if (Math.abs(currentTop - targetLocation) < this.speed) {
            this.speed = Math.abs(currentTop - targetLocation)
          }
          if (targetLocation < currentTop) {
            currentTop -= this.speed
          }
          if (targetLocation > currentTop) {
            currentTop += this.speed
          }
          window.scrollTo(0, currentTop)
          if (currentTop === targetLocation) {
            window.clearInterval(this.backTimer)
            this.backTimer = -1
          }
          this.speed += 15
        }, 10)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.solution {
  width: 100%;
  height: auto;
  background-color: $bgcolor-main;
  user-select: none;
  .solution-container {
    padding-top: 30px;
    .title {
      position: relative;
      padding-left: 16px;
      line-height: 28px;
      font-size: $fontsize-main;
      font-weight: $fontweight-highlight;
      color: $fontcolor-main;
    }
    .title::before {
      position: absolute;
      left: 0;
      bottom: 0;
      content: "";
      width: 6px;
      height: 28px;
      background-color: $bgcolor-theme;
    }
    .describe {
      font-size: $fontsize-describe;
      color: $fontcolor-main;
      .per-paragraph {
        text-indent: 2em;
      }
    }
    .img {
      width: 100%;
      height: auto;
      img {
        width: 1200px;
      }
    }
    .operator {
      width: 100%;
      height: 599px;
      margin-bottom: 60px;
      .describe {
        margin-bottom: 30px;
      }
    }
    .public-security {
      width: 100%;
      height: 607px;
      margin-bottom: 60px;
    }
    .intelligent-transportation {
      width: 100%;
      height: 586px;
      margin-bottom: 60px;
    }
    .smart-pension {
      width: 100%;
      height: 1004px;
      margin-bottom: 60px;
      .img:first-child {
        margin-bottom: 30px;
      }
    }
    .intelligent-epidemic-prevention {
      width: 100%;
      height: 1194px;
      margin-bottom: 60px;
      .img:first-child {
        margin-bottom: 14px;
      }
    }
    .smart-site {
      width: 100%;
      height: 580px;
      margin-bottom: 60px;
    }
    .intelligent-agriculture {
      width: 100%;
      height: 898px;
      margin-bottom: 60px;
      .describe, .img {
        margin-bottom: 30px;
      }
    }
    .rural-revitalization {
      width: 100%;
      height: 1096px;
      margin-bottom: 60px;
      .describe, .img {
        margin-bottom: 30px;
      }
    }
    .drones {
      width: 100%;
      height: 598px;
      margin-bottom: 60px;
    }
    .business_big_data {
      width: 100%;
      height: 600px;
      margin-bottom: 60px;
      .describe {
        margin-bottom: 30px;
      }
    }
    .dynamic-signal-control {
      width: 100%;
      height: 664px;
      margin-bottom: 139px;
      .describe {
        margin-bottom: 30px;
      }
    }
  }
}
</style>
